var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({class:[_vm.$style.button, _vm.disabled && _vm.$style.disabled, _vm.active && _vm.$style.active]},'button',_vm.$attrs,false),!_vm.disabled && _vm.$listeners),[(_vm.loading)?_c('loading-loader',{attrs:{"is-loading":_vm.loading,"size":7,"delay":0}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }